import React from 'react';
const FailedSVG = ({ color = 'black', className, onClick }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='15'
      viewBox='0 0 14 15'
      fill='none'
      className={className}
      onClick={onClick}
    >
      <path
        d='M7 10.8269V10.8336M7 4.16691V8.83358M13 7.50024C13 10.814 10.3137 13.5002 7 13.5002C3.68629 13.5002 1 10.814 1 7.50024C1 4.18654 3.68629 1.50024 7 1.50024C10.3137 1.50024 13 4.18654 13 7.50024Z'
        stroke='#C81111'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default FailedSVG;
